import { X } from "lucide-react";

export const ConfirmationModal = ({ isOpen, setIsOpen, onClose, onConfirm, title, message, cancelBtn, confirmBtn, tempWarning }) => {
    if (!isOpen) return null;
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4 shadow-xl">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-bold">{title}</h3>
            <button
              onClick={() => setIsOpen(false)}
              className="text-brandDefault"
            >
              <X size={24} />
            </button>
          </div>
          
          <p className="text-brandDefault text-center mb-10">{message}</p>
          {tempWarning && (<p className="text-red-500 text-center -mt-8 mb-10">{tempWarning}</p>)}

          <div className="flex justify-center gap-3">
            <button
              onClick={onClose}
              className="w-[7.75rem] py-2 border border-brandDefault text-brandDefault rounded-lg"
            >
              {cancelBtn}
            </button>
            <button
              onClick={onConfirm}
              className="w-[7.75rem] py-2 border border-brandDefault bg-brandDefault text-white rounded-lg"
            >
              {confirmBtn}
            </button>
          </div>
        </div>
      </div>
    );
  };